import { DetectorStateI } from '../redux/types/app';

export const MAX_CONNECTED_ACTUATORS_PER_DETECTOR = 100;

const toUniqueIds = (ids: number[] = []) => Array.from(new Set(ids));

export const getDetectorConnectedActuatorIds = (detector?: DetectorStateI): number[] => {
    return toUniqueIds(detector?.connectedActuatorIds ?? []).slice(0, MAX_CONNECTED_ACTUATORS_PER_DETECTOR);
};

export const isActuatorConnectedToDetector = (detector: DetectorStateI | undefined, actuatorId: number): boolean => {
    return getDetectorConnectedActuatorIds(detector).includes(actuatorId);
};

export const getDetectorState = (detector?: DetectorStateI): 'ok' | 'error' => {
    return getDetectorConnectedActuatorIds(detector).length > 0 ? 'ok' : 'error';
};

export const connectActuatorToDetector = (detector: DetectorStateI, actuatorId: number): { detector: DetectorStateI; connected: boolean } => {
    const current = getDetectorConnectedActuatorIds(detector);

    if (current.includes(actuatorId)) {
        return { detector: { ...detector, connectedActuatorIds: current }, connected: true };
    }

    if (current.length >= MAX_CONNECTED_ACTUATORS_PER_DETECTOR) {
        return { detector: { ...detector, connectedActuatorIds: current }, connected: false };
    }

    const nextConnectedActuatorIds = [...current, actuatorId];
    return {
        detector: { ...detector, connectedActuatorIds: nextConnectedActuatorIds, state: 'ok' },
        connected: true
    };
};

export const disconnectActuatorFromDetector = (detector: DetectorStateI, actuatorId: number): DetectorStateI => {
    const nextConnectedActuatorIds = getDetectorConnectedActuatorIds(detector).filter((id) => id !== actuatorId);
    return {
        ...detector,
        connectedActuatorIds: nextConnectedActuatorIds,
        state: nextConnectedActuatorIds.length > 0 ? 'ok' : 'error'
    };
};
